import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  saveDesignReloadPricebreaks,
  addDesignToCart,
  updateQuantity,
  pricebreaks,
} from "../../actions";
import Review from "../../components/Review";
import queryString from "query-string";

class ReviewContainer extends React.Component {
  componentDidMount() {
    // See if the design is dirty.
    const isAdmin = this.props.user.loggedIn && this.props.user.isAdmin;
    const isAdminEditingOrCopying =
      isAdmin &&
      (this.props.admin.action.actionType === "edit" ||
        this.props.admin.action.actionType === "copy");
    if (
      !isAdminEditingOrCopying &&
      this.props.design.id &&
      this.props.design.version !== this.props.dirtyDesign.savedVersion
    ) {
      //console.log('saving design and reloading price breaks in ReviewContainer')
      this.props.saveDesignReloadPricebreaks();
    } else {
      this.props.requestPricebreaks();
    }
  }

  componentDidUpdate(prevProps) {
    // If the user loads the review page first, the component will mount before the design is loaded. so, load the price breaks.
    if (typeof prevProps.design.id === "undefined" && this.props.design.id) {
      //console.log('requesting pricebreaks in ReviewContainer')
      this.props.requestPricebreaks();
    }

    // first - don't do any updating if pricebreaks has not loaded yet
    if (this.props.pricebreaks.pricebreaks) {
      // if there is no quantity already set previously
      if (!prevProps.quantity.quantity || prevProps.quantity.quantity === 0) {
        let query = queryString.parse(this.props.location.search);
        let doUpdate = false;
        let newQuantity = null;

        // if a quantity was specified
        if (query.quantity) {
          // save this quantity
          newQuantity = query.quantity;
          doUpdate = true;
          // if we have a minimum
          if (this.props.minimumQuantity) {
            // if the specified qty is below the minimum use the minimum
            newQuantity = Math.max(newQuantity, this.props.minimumQuantity);
          }
          // if we have an increment
          if (this.props.quantityIncrement) {
            // if new quantity is not an even increment
            if (newQuantity % this.props.quantityIncrement !== 0) {
              // Multiplier to round to the next valid quantity.
              let factor = Math.ceil(
                newQuantity / this.props.quantityIncrement,
              );
              newQuantity = factor * this.props.quantityIncrement;
            }
          }

          // no quantity specified
        } else {
          // if there is a min qty
          if (this.props.minimumQuantity) {
            // potentially use min as initial qty
            newQuantity = this.props.minimumQuantity;
            doUpdate = true;
          }

          let quantities = [];
          if (this.props.pricebreaks.pricebreaks) {
            quantities = Object.keys(this.props.pricebreaks.pricebreaks);
          }
          // if there are at least 4 price levels
          if (quantities.length >= 4) {
            // use price level 4 as initial qty
            newQuantity = quantities[3];
            doUpdate = true;
          }
        }

        // if we changed the qty
        if (doUpdate) {
          // update it
          this.props.updateQuantity(newQuantity);
        }
      }
    }
  }

  onAddDesignToCart = (payload) => {
    this.props.addDesignToCart({
      design_id: this.props.design.id,
      quantity: this.props.quantity.quantity,
      comments: payload.comments,
      largePlate: payload.largePlate,
      proof: payload.proof,
      orderId: payload.orderId,
    });
  };

  render() {
    if (this.props.design.id) {
      return (
        <Review
          routeId={this.props.routeId}
          location={this.props.location}
          addToCart={this.onAddDesignToCart}
          pricebreaksList={this.props.pricebreaks.pricebreaks}
          upchargesList={this.props.upcharges}
          pricebreaksLoading={this.props.pricebreaks.loading}
          minimumQuantity={this.props.minimumQuantity}
          quantityIncrement={this.props.quantityIncrement}
          quantity={this.props.quantity.quantity}
          savings={this.props.quantity.savings}
        />
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    dirtyDesign: state.dirtyDesign,
    quantity: state.quantity,
    pricebreaks: state.pricebreaks,
    upcharges: state.pricebreaks.upcharges,
    minimumQuantity: state.pricebreaks.minimumQuantity,
    quantityIncrement: state.pricebreaks.quantityIncrement,
    user: state.user,
    admin: state.admin,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addDesignToCart: addDesignToCart.request,
      saveDesignReloadPricebreaks: saveDesignReloadPricebreaks,
      requestPricebreaks: pricebreaks.request,
      updateQuantity,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewContainer);
